/*
 * 封装几个api请求
 */

import request from "../utils/request";

export async function querySetting() {
    return request("/get/?info=system", {
        method: "GET",
    });
}

export async function queryCates() {
    return request("/get/?info=category", {
        method: "GET",
    });
}

export async function queryChildren() {
    return request("/get/?info=children", {
        method: "GET",
    });
}

/**
 * from/to 为可选月份（'YYYY-MM'），按北京时间圈定范围，两端月份都完整包含
 */
export async function queryDaily({ page, rows, child, q, from, to } = {}) {
    return request("/list", {
        method: "GET",
        params: {
            page,
            rows,
            child,
            q,
            from,
            to,
        },
    });
}

/**
 * 各年份记录数（搜索浮层「按年份跳」导航用）。
 * q/child 与 queryDaily 语义一致，年份计数即当前筛选条件下的命中数。
 */
export async function queryYears({ q, child } = {}) {
    return request("/list/years", {
        method: "GET",
        params: {
            q,
            child,
        },
    });
}

export async function queryDailyItem(id) {
    return request(`/item/${id}`, {
        method: "GET",
    });
}

export async function getAuthread(pwd) {
    return request("/read-access/sessions", {
        requestType: "json",
        data: {
            password: pwd,
        },
    });
}

export async function queryReadAccess() {
    return request("/read-access/session", {
        method: "GET",
        skipAuthRefresh: true,
    });
}

export async function queryUploadToken() {
    return request("/uptoken", { method: "GET" });
}

export async function queryLogin({ username, password } = {}) {
    return request("/auth/sessions", {
        data: {
            username,
            password,
        },
        requestType: "json",
    });
}

/**
 * 设置一个分类，只能唯一
 * @param {String} name 分类名称
 */
export async function setCates(name) {
    return request("/category", {
        data: {
            name: name,
        },
    });
}

export async function DiggItem(id) {
    return request("/digg", {
        data: {
            id,
        },
    });
}

export async function getPrefop(id) {
    return request("/prefop", {
        method: "GET",
        params: {
            id,
        },
    });
}

/**
 * 发布文章
 * @param {String} txt 文章正文
 * @param {Number} role 发布者角色
 * @param {Array} images 发布的图片
/**
 * 发布文章
 * @param {Object} addrGps 地理位置信息
 * @param {Array} watcherNos 「是谁」多选，如 [1, 3]
 */
export async function setPost({
    txt,
    role,
    images = [],
    addrGps = {},
    cate,
    watcherNos = [],
} = {}) {
    return request("/item", {
        data: {
            txt,
            role,
            images: JSON.stringify(images),
            addrGps: JSON.stringify(addrGps),
            cate,
            // requestType 是 form，数组必须序列化成字符串后由后端 toIntList 解析
            watcher_nos: JSON.stringify(watcherNos || []),
        },
    });
}

/**
 * 更新文章
 * @param {Number} id 文章id
 * @param {String} txt 文章正文
 * @param {Number} role 发布者角色
 * @param {Array} images 发布的图片
 * @param {Array} watcherNos 「是谁」多选；不传表示不改动该项
 */
export async function updatePost({
    id,
    txt,
    role,
    images = [],
    cate,
    watcherNos = null,
} = {}) {
    const data = { id, txt, role, images: JSON.stringify(images), cate };
    // null = 本次不碰「是谁」；数组（含空数组 = 清空）才提交
    if (watcherNos !== null) {
        data.watcher_nos = JSON.stringify(watcherNos);
    }
    return request("/update", { data });
}

/**
 * 删除文章
 * @param {Number} id 文章id
 */
export async function deletePost(id) {
    return request("/delete", {
        method: "GET",
        params: {
            id: id,
        },
    });
}

/**
 * 批量删除文章。后端会在同一事务中删除记录并同步站点、分类计数。
 * @param {String[]} ids 记录 id，单次最多 100 条
 */
export async function deletePosts(ids = []) {
    return request("/delete-batch", {
        data: {
            ids: JSON.stringify(ids),
        },
    });
}

/**
 * 获取文章详情
 * @param {Number} id 文章id
 */
export async function editPost(id) {
    return request("/article", {
        method: "GET",
        params: {
            id: id,
        },
    });
}

/**
 * 根据视频key触发七牛云的任务队列，异步执行
 * @param {String} srcKey 视频key
 */
export async function queryPfop(srcKey) {
    return request("/pfop", {
        method: "GET",
        params: {
            srcKey: srcKey,
        },
    });
}

/**
 * 系统设置接口
 * @param {String} sitename 站点名
 * @param {String} avatar 头像地址
 * @param {String} bgimg 背景图地址
 * @param {String} count 一次拉取item的数量
 * @param {String} role 角色配置
 */
export async function setSystem(params) {
    return request("/set", {
        data: {
            ...params,
            children: Array.isArray(params?.children)
                ? JSON.stringify(params.children)
                : params?.children,
        },
    });
}

/**
 * 退出登录账号接口
 */
export async function Logout(_params) {
    return request("/auth/session", {
        method: "DELETE",
    });
}
